import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './HelpCenter.module.css';
import { ArrowLeftIcon } from '../components/Icons';

const HelpCenter = () => {
  const navigate = useNavigate();

  const sections = [
    {
      title: '开始阅读',
      points: [
        '在「发现」或「书架」页面选择一本感兴趣的书籍并进入详情页。',
        '点击章节目录中的任一章节即可进入阅读模式。',
        '阅读过程中可收藏单词、句子或添加笔记，方便日后复习。'
      ],
    },
    {
      title: '收藏与学习',
      points: [
        '在章节阅读页点击高亮按钮即可收藏当前单词或句子。',
        '前往「学习中心」或书籍详情页的学习入口，可集中复习已收藏内容。',
        '单词学习支持自动播放、循环次数等个性化设置。'
      ],
    },
    {
      title: '历史与统计',
      points: [
        '「个人中心 → 阅读历史」可查看近期阅读与收藏记录。',
        '章节阅读会自动加入历史，方便快速返回继续阅读。',
        '收藏的单词和句子均可在历史页或学习页管理、取消收藏。'
      ],
    },
    {
      title: '常见问题',
      points: [
        '若遇到加载缓慢，请检查网络连接或稍后重试。',
        '收藏后没有立即显示，可尝试刷新页面或重新打开学习入口。',
        '如需反馈问题，欢迎在「个人中心 → 用户反馈」提交。'
      ],
    },
  ];

  return (
    <div className={styles.helpCenter}>
      <header className={styles.header}>
        <button
          type="button"
          className={styles.backBtn}
          onClick={() => navigate(-1)}
          aria-label="返回"
        >
          <ArrowLeftIcon size={20} />
        </button>
        <div className={styles.title}>帮助中心</div>
      </header>

      <div className={styles.content}>
        {sections.map(section => (
          <section key={section.title} className={styles.section}>
            <h2 className={styles.sectionTitle}>{section.title}</h2>
            <ul className={styles.sectionList}>
              {section.points.map(point => (
                <li key={point}>{point}</li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </div>
  );
};

export default HelpCenter;
